import { createRouter, createWebHistory } from "vue-router";
import { routes } from "./routes";
import { roles, getHomeRouteName } from "@/config/config";

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  const isAuthenticated = localStorage.getItem("userData");

  console.log("to",to)
  console.log("from",from)

  if (to.meta.requiresAuth && !isAuthenticated) {

    const userAuth = {
      params: to.name === "timetableWeeklyStudent" ? to.params.qrCode : ''
    }

    localStorage.setItem("userAuth",JSON.stringify(userAuth));
    next({ name: "verification" });
  } else {
    if (to.meta.guest && isAuthenticated) {

      next({name:"home"});

    }else{

      if(to.name === 'root'){
        next({name:"home"});
      }else{
        next()
      }
      
    }
  }
});

export default router;
